/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 热门抢票项目
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.HotSaleProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/product/hot-sale`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
